import { useEffect, useState } from "react";
import { Card, Space, Spin, Row, Col, Button, Typography, Image } from "antd";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";

import publicDataServices from "../../../APIs/publicDataServices";

import PageTitle from "../../../Components/PageTitle/pageTitle";

import { settings } from "../../../Services/apiSetting";

const { Title, Paragraph } = Typography;

const Catalog = () => {
  const [catalogData, setCatalogData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCatalog = async () => {
      const response = await publicDataServices.getCatalogs();

      //   console.log("Catalog Data:", JSON.parse(response.data.data));

      const mappedData = JSON.parse(response.data.data).map((item) => ({
        ...item,
        CoverPhoto: settings.catalogsImageFolder + item.CoverPhoto.trim(),
        FileName: settings.catalogsFileFolder + item.FileName.trim(),
      }));

      setCatalogData(mappedData);

      setIsLoading(false);
    };

    fetchCatalog();
  }, []);

  return (
    <Space direction="vertical" className="page-container">
      {isLoading && (
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          fullscreen
        />
      )}

      <PageTitle title="Catalogs" subTitle="Browse our catalog of products" />

      <Row gutter={[24, 24]} justify="flex-start" style={{ marginTop: 16 }}>
        {catalogData.map((item, index) => (
          <Col
            key={index}
            xs={24} // 1 per row
            sm={12} // 2 per row (optional intermediate)
            md={12} // 2 per row (768–991px)
            lg={8} // 3 per row (992–1439px)
            xl={8} // 3 per row (≥1440px)
            xxl={6}
          >
            <Card
              style={{ height: "100%", borderRadius: 8 }}
              styles={{
                body: {
                  padding: 20,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                },
              }}
              cover={
                <Image
                  alt={item.Title}
                  src={item.CoverPhoto}
                  style={{
                    height: 200,
                    objectFit: "contain",
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                  }}
                />
              }
            >
              <Title level={5} style={{ marginBottom: 8, marginTop: 0 }}>
                {item.Title}
              </Title>

              <Paragraph type="secondary" style={{}}>
                {item.SubTitle}
              </Paragraph>

              <Button
                type="primary"
                icon={<DownloadOutlined />}
                block
                style={{ marginTop: "auto", color: "black" }}
                onClick={() => {
                  window.open(item.FileName, "_blank");
                }}
              >
                Download PDF
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </Space>
  );
};

export default Catalog;
